import { confidentialHTML } from '@webapp/landing/src/components/ru/docs/html/confidential';

import { Doc } from './doc';

export const Confidential: FC = () => (
    <Doc html={confidentialHTML} subTitle='Политика конфиденциальности' title='Оферта, договоры' />
);
